'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  storeOne (model) {
    return new Promise((resolve, reject) => {
      Axios.post('/1.0/users', {users: [model]})
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  updateOne (model) {
    return new Promise((resolve, reject) => {
      Axios.put('/1.0/users', {users: [model]})
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchOneCompany () {
    return new Promise((resolve, reject) => {
      Axios.get(`/1.0/user-companies`)
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  updateOneCompany (model) {
    return new Promise((resolve, reject) => {
      Axios.put(`/1.0/user-companies`, {companies: [model]})
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  saveOneCompanyLogo (companyId, blob, onProgress) {
    return new Promise((resolve, reject) => {
      let data = new FormData()
      data.append('logo', blob)

      Axios.post(
        `1.0/user-companies/${companyId}/logo`,
        data,
        {
          onUploadProgress: (event) => {
            let completed = Math.ceil((event.loaded * 100) / event.total)

            console.info(completed)

            onProgress && onProgress({completed})
          }
        }
      )
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchOneUser (email) {
    return Axios.get(`/1.0/users/${email}`)
      .then(response => {
        const parsedResponse = parseResponse(response)
        
        return {
          data: parsedResponse.data.pop(),
          meta: parsedResponse.meta
        }
      })
      .catch(err => {
        return Promise.reject(handleError(err));
      })
  },

  saveUserLogo (email, logo) {
    return new Promise((resolve, reject) => {
      let data = new FormData()
      data.append('logo', logo, (new Date()).toJSON())

      Axios.post(`1.0/users/${email}/logo`, data)
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  requestUserEmailChange (oldEmail, newEmail) {
    return new Promise((resolve, reject) => {
      Axios.post('1.0/user-emails-activation', {users: [{ email: oldEmail, new_email: newEmail }]})
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  },

  requestUserEmailConfirm ({hash, locale}) {
    return new Promise((resolve, reject) => {
      Axios.put(`/1.0/user-emails-activation/${hash}`, {}, {
        headers: {'Accept-Language': locale}
      })
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  },

  fetchNotificationsPeriods () {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/user-notification-periods')
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  },

  updateNotificationsPeriods ({ enabled, periods }) {
    return new Promise((resolve, reject) => {
      Axios.put('/1.0/user-notification-periods', { enabled, periods })
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  }
}
